<template>
  <dv-scroll-board :config="config" style="100%" />
</template>

<script>
import { problems_info } from "../api/getData";

export default {
  data() {
    return {
      config: {},
    };
  },
  methods: {
    async makeProblemReport() {
      let problem_data = await problems_info();
      let config_data = [];
      problem_data.data.data.problems_info.forEach((element) => {
        let config_data_unit = [];
        // config_data_unit.push(element.eventid);
        config_data_unit.push(element.clock);
        config_data_unit.push(element.duringtime);
        config_data_unit.push(element.severity);
        config_data_unit.push(element.hostname);
        config_data_unit.push(element.description);
        config_data.push(config_data_unit);
      });
      this.config = {
        header: ["发生时间", "持续时间", "级别", "主机名", "详情"],
        rowNum: 5, //表行数
        headerBGC: "#111217", //表头背景色
        oddRowBGC: "#111217", //奇数行背景色
        evenRowBGC: "#192a41", //偶数行背景色
        waitTime: "2000", //轮播时间间隔(ms)
        headerHeight: "40",
        columnWidth: [160, 120, 60, 300],
        carousel:
          problem_data.data.data.problems_info.length > 60 ? "page" : "single",
        data: config_data,
      };
    },
  },
  mounted() {
    this.makeProblemReport();
    //更新数据
    // problems_info().then((data) => {
    //   this.config.data = data.data.data.problems_info;
    // });
    //设置定时刷新
    setInterval(() => {
      this.makeProblemReport();
    }, 60000);
  },
};
</script>

<style lang="less" scoped>
@import "../style/common";
@import "../style/mixin";
// @import "../style/temp";
table {
  font-family: arial, sans-serif;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  width: 100px;
}

tr:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.5);
}

th {
  background-color: rgba(0, 0, 0, 0.1);
}

.body-right {
  min-width: 255px;
  flex: 5;
  position: relative;
  color: #aaa;
  font-weight: bold;
  font-size: 20px;

  .title {
    font-family: "Microsoft YaHei";
    font-weight: 400;
    font-size: 18px;
    color: #aaa;
    box-shadow: -3px -3px 10px 2px rgba(29, 33, 41, 0.1);
    background-color: rgba(255, 255, 255, 0.1);
    width: 100%;
    display: inline-block;
    // margin-top: 20px;
    height: 40px;

    .event_id {
      position: absolute;
      top: 10px;
      left: 26px;
    }

    .event_time {
      position: absolute;
      top: 10px;
      left: 135px;
    }

    .event_host {
      position: absolute;
      top: 10px;
      left: 320px;
    }

    .event_name {
      position: absolute;
      top: 10px;
      left: 590px;
    }

    .event_severity {
      position: absolute;
      top: 10px;
      left: 840px;
    }

    .event_during {
      position: absolute;
      top: 10px;
      left: 930px;
    }
  }

  .body-right-table {
    box-shadow: 1px 3px 5px 2px rgba(29, 33, 41, 0.1);
    height: 560px;

    .seamless-warp {
      height: 100%;
      overflow: hidden;

      ul li:nth-child(2n-1) {
        background-color: rgba(0, 0, 0, 0.01);
      }

      ul li:nth-child(2n) {
        background-color: rgba(255, 255, 255, 0.2);
      }

      .item {
        .content {
          text-align: center;
          height: 30px;
          line-height: 30px;
          margin: 0 12px;
          overflow: hidden;
          display: inline-block;
          font-family: "Source Han Sans CN";
          font-weight: 400;
          font-size: 18px;
        }

        .content_id {
          width: 50px;
        }

        .content_time {
          width: 180px;
        }

        .content_host {
          width: 120px;
        }

        .content_name {
          width: 390px;
        }

        .content_severity_warn {
          color: red;
          width: 40px;
          margin: 0px;
          overflow: hidden;
          font-family: "Source Han Sans CN";
          font-weight: 400;
          // font-size: 16px;
        }

        .content_severity_normal {
          // color: red;
          width: 40px;
          margin: 0px;
          overflow: hidden;
          font-family: "Source Han Sans CN";
          font-weight: 400;
          // font-size: 16px;
        }

        .content_during {
          overflow: hidden;
          margin: 0px;
          width: 140px;
        }
      }
    }
  }
}
</style>